import { noProps } from "./shared";

/**
 * Events related to NBN design projects.
 */
export const designNbn = {
  "design.nbn.project-code.saved": noProps.describe("User changed and saved the project code for an NBN project"),
};
